import type { FC } from 'react';
import React from 'react';
import {
  Body,
  Box,
  Button,
  Flex,
  Image,
} from '@edreamsodigeo/prisma-design-system';
import { useRouter, useTranslation } from '@edreamsodigeo/frontend-core';

export const SEARCH_SENTENCE_MIN_HEIGHT = 111;
const RESULT_LINK = 'results';

const NoResults: FC = () => {
  const { t } = useTranslation();
  const { push } = useRouter();

  const onClickGoToResults = (): void => {
    push(RESULT_LINK);
  };

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      pt="1x_big"
      px="3x_big"
      sx={{
        minHeight: `calc(100vh - ${SEARCH_SENTENCE_MIN_HEIGHT}px)`,
      }}
    >
      <Box mb="1x_big">
        <Body color="neutral.70" type="base" textAlign="center">
          {t('flightSummary.meta.noResults.info')}
        </Body>
      </Box>
      <Box mb="base">
        <Button onClick={onClickGoToResults}>
          {t('flightSummary.meta.noResults.retry')}
        </Button>
      </Box>
      <Image
        src="/images/onefront/branded/deals_not_found.png"
        alt="No results image"
        style={{
          width: '200%',
          position: 'absolute',
          bottom: 0,
        }}
      />
    </Flex>
  );
};

export default NoResults;
